export default {
  SET_PAGE_TITLE: "SET_PAGE_TITLE",
};
